// GENERATED by fritz2 - NEVER CHANGE CONTENT MANUALLY!
package de.oevbs.kunde.kundenportal2.model.services.deregistercar

import de.oevbs.businesspartner.bpcrmservice2.partner.model.Country
import de.oevbs.businesspartner.bpcrmservice2.partner.model.Salutation
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import dev.fritz2.core.Lens
import dev.fritz2.core.lensOf
import kotlin.String
import kotlinx.datetime.LocalDate

public fun DeregisterCar.Companion.unsubDate(): Lens<DeregisterCar, LocalDate?> = lensOf(
    "unsubDate",
    { it.unsubDate },
    { p, v -> p.copy(unsubDate = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.unsubDate(): Lens<PARENT, LocalDate?> = this +
    DeregisterCar.unsubDate()

public fun DeregisterCar.Companion.vehicleAction(): Lens<DeregisterCar, String> = lensOf(
    "vehicleAction",
    { it.vehicleAction },
    { p, v -> p.copy(vehicleAction = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.vehicleAction(): Lens<PARENT, String> = this +
    DeregisterCar.vehicleAction()

public fun DeregisterCar.Companion.selectedCarContract(): Lens<DeregisterCar, CarContract?> =
    lensOf(
    "selectedCarContract",
    { it.selectedCarContract },
    { p, v -> p.copy(selectedCarContract = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.selectedCarContract(): Lens<PARENT, CarContract?> =
    this + DeregisterCar.selectedCarContract()

public fun DeregisterCar.Companion.selectedCountry(): Lens<DeregisterCar, Country> = lensOf(
    "selectedCountry",
    { it.selectedCountry },
    { p, v -> p.copy(selectedCountry = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.selectedCountry(): Lens<PARENT, Country> = this +
    DeregisterCar.selectedCountry()

public fun DeregisterCar.Companion.salutationBuyer(): Lens<DeregisterCar, Salutation> = lensOf(
    "salutationBuyer",
    { it.salutationBuyer },
    { p, v -> p.copy(salutationBuyer = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.salutationBuyer(): Lens<PARENT, Salutation> = this +
    DeregisterCar.salutationBuyer()

public fun DeregisterCar.Companion.companyBuyer(): Lens<DeregisterCar, String> = lensOf(
    "companyBuyer",
    { it.companyBuyer },
    { p, v -> p.copy(companyBuyer = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.companyBuyer(): Lens<PARENT, String> = this +
    DeregisterCar.companyBuyer()

public fun DeregisterCar.Companion.firstnameBuyer(): Lens<DeregisterCar, String> = lensOf(
    "firstnameBuyer",
    { it.firstnameBuyer },
    { p, v -> p.copy(firstnameBuyer = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.firstnameBuyer(): Lens<PARENT, String> = this +
    DeregisterCar.firstnameBuyer()

public fun DeregisterCar.Companion.lastnameBuyer(): Lens<DeregisterCar, String> = lensOf(
    "lastnameBuyer",
    { it.lastnameBuyer },
    { p, v -> p.copy(lastnameBuyer = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.lastnameBuyer(): Lens<PARENT, String> = this +
    DeregisterCar.lastnameBuyer()

public fun DeregisterCar.Companion.streetNameBuyer(): Lens<DeregisterCar, String> = lensOf(
    "streetNameBuyer",
    { it.streetNameBuyer },
    { p, v -> p.copy(streetNameBuyer = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.streetNameBuyer(): Lens<PARENT, String> = this +
    DeregisterCar.streetNameBuyer()

public fun DeregisterCar.Companion.streetNumberBuyer(): Lens<DeregisterCar, String> = lensOf(
    "streetNumberBuyer",
    { it.streetNumberBuyer },
    { p, v -> p.copy(streetNumberBuyer = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.streetNumberBuyer(): Lens<PARENT, String> = this +
    DeregisterCar.streetNumberBuyer()

public fun DeregisterCar.Companion.postalCodeBuyer(): Lens<DeregisterCar, String> = lensOf(
    "postalCodeBuyer",
    { it.postalCodeBuyer },
    { p, v -> p.copy(postalCodeBuyer = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.postalCodeBuyer(): Lens<PARENT, String> = this +
    DeregisterCar.postalCodeBuyer()

public fun DeregisterCar.Companion.locationBuyer(): Lens<DeregisterCar, String> = lensOf(
    "locationBuyer",
    { it.locationBuyer },
    { p, v -> p.copy(locationBuyer = v)}
  )

public fun <PARENT> Lens<PARENT, DeregisterCar>.locationBuyer(): Lens<PARENT, String> = this +
    DeregisterCar.locationBuyer()
